import styled from "styled-components";
import { 
    Form as AntForm ,
    Typography as AntTypography,
    Button as AntButton,
  } from "antd";
import { BackArrow } from '@assets';
import lightTheme from '@styles/theme';
import { AuthBg, AuthLogo } from "@assets/auth";


export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }

  .ant-form-item{
    margin-bottom: 12px;
  }

  .ant-form-item:nth-child(2) {
    margin-bottom: 0;
  }

`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 16px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 25px;
  height: 25px;
`;

export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px 0 24px;
`

export const Title = styled(AntTypography.Title)`
  color: #FFC654 !important;
  text-align: center;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const Form = styled(AntForm)`
  margin-top: 24px;
  width: 100%;
  
  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    margin: 0px 0 2px 8px;
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .ant-input-affix-wrapper {
    border: 1px solid #e1cce0;
    border-radius: 10px;

    input {
      text-align: center;
    }
  }

  .ant-btn{
    margin-top: 8px;
  }

`;

export const TextButton = styled(AntButton)`
  float: right;
  text-align: right;
  color: #fff;
  margin-top: -100px;
  padding: 0 0px 0 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover{
    color: #fff !important;
  }
`


